import { ResetPasswordLayout } from "../common/FormLayouts";
import { ResetPasswordProps } from "../common/types";
import { ForgotPassword, ResetForm } from "../ui/Forms/ResetPasswordForms";

const ResetPassword: React.FC<ResetPasswordProps> = ({ isResetForm }) => {
  return (
    <>
      <ResetPasswordLayout>
        <strong>
          {isResetForm ? "Reset password" : "Forgot password?"}
        </strong>

        <div className="envelop">
          <p className="centerTxt ">
            {isResetForm ? "" : "Enter the email associated with your account"}
          </p>

          <div className="CoverDiv">
            {isResetForm ? (
              <ResetForm isResetForm={isResetForm} />
            ) : (
              <ForgotPassword isResetForm={isResetForm} />
            )}
          </div>
        </div>
      </ResetPasswordLayout>
    </>
  );
};

export default ResetPassword;
